import React, { PureComponent } from 'react';

import './Message.css';

export class Message extends PureComponent {
  static displayName = Message.name;

  render() {
    return (
      <div className="pwx-message-container">
        <span className="pwx-message-content">
          {this.props.messageContent}
        </span>
      </div>
    );
  }
}